<template>

    <footer class="footer font-small text-center">
      
              <ul class="list-inline">
                <li class="social-item list-inline-item">
                  <a href="https://twitter.com/" alt="twitter">
                      <i class="fab fa-twitter-square"></i>
                  </a>
                </li>
                <li class="social-item list-inline-item">
                  <a href="https://www.facebook.com/zuzka.gabonayova" alt="facebook">
                      <i class="fab fa-facebook-square"></i>
                  </a>
                </li>
                <li class="social-item list-inline-item">
                  <a href="https://github.com/ZuzanaGabonayova" alt="github">
                      <i class="fab fa-github-square"></i>
                  </a>
                </li>
                <li class="social-item list-inline-item">
                  <a href="https://www.linkedin.com/in/zuzana-gabonayova/" alt="linkedin">
                      <i class="fab fa-linkedin"></i>
                  </a>
                </li>
                <li class="social-item list-inline-item">
                  <a href="https://www.instagram.com/sjuzn36/" alt="instagram">
                      <i class="fab fa-instagram"></i>
                  </a>
                </li>
                <!-- <li class="social-item list-inline-item">
                  <a href="https://snapchat.com" alt="snapchat">
                      <i class="fab fa-snapchat-square"></i>
                  </a>
                </li> -->
              </ul>
          
              <div class="copyright">
                <p>
                  Copyright © 2022 Zuzana Gabonayová. All Rights Reserved.
                </p>
              </div>
              
            </footer>
  
  </template>